import React from "react";
import "./Next_Btn.css";

const Next_Btn = ({
  text = "Click Me",
  onClick,
  type = "button",
  className = "",
}) => {
  return (
    <div className="Next_Btn_div">
      <button type={type} className={`Next_Btn ${className}`} onClick={onClick}>
        {text}
      </button>
    </div>
  );
};

export default Next_Btn;
